import React, { Component } from "react";
import { connect } from "react-redux";
import { BlankTemplate } from "../BlankTemplate";
import { LoginForm } from "./LoginForm";
import { authConstants } from "../../constants";
import "./loginPage.scss";

class LoginPage extends Component {
  componentDidMount() {
    // store location state (from router) if some private router redirect to login
    const redirectFrom = this.props.location.state;
    this.props.dispatch({
      type: authConstants.AUTH_LOGIN_REDIRECT,
      payload: redirectFrom,
    });
  }

  render() {
    return (
      <BlankTemplate>
        <div id="loginPage" className="registerPage">
          <div className="rightSide" />
          <div className="leftSide">
            <LoginForm />
          </div>
        </div>
      </BlankTemplate>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authReducer,
  };
};

const LoginPageWithRedux = connect(mapStateToProps)(LoginPage);

export { LoginPageWithRedux as LoginPage };



// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginPage.jsx